import axios from 'axios';
import { toast } from 'vue3-toastify';

import { useAuthStore } from '@bv/stores';

import { getCookie } from './cookieUtils';

const axiosInstance = axios.create({});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore();
    const token: string | null = authStore.impersonateToken || authStore.token;

    const serviceId = getCookie('new-chat-x-service-id');
    const workspaceId = getCookie('x-workspace-id');

    Object.assign(config.headers, {
      Accept: '*',
      'Content-type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'x-workspace-id': workspaceId,
      'x-service-id': serviceId,
      Authorization: token ? `Bearer ${token}` : undefined,
    });

    if (config.data instanceof FormData) {
      config.headers['Content-type'] = 'multipart/form-data';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    const errorMsg = error.response.data.errors;

    for (const field in errorMsg) {
      if (!(errorMsg[field] instanceof Object)) {
        toast(errorMsg[field], {
          type: 'error',
          position: 'top-right',
          autoClose: 10000,
        });
      } else {
        for (const error in errorMsg[field]) {
          const msg = errorMsg[field][error];
          if (typeof msg == 'string') {
            toast(msg, {
              type: 'error',
              position: 'top-right',
              autoClose: 10000,
            });
          } else {
            for (const m in msg) {
              toast(msg[m], {
                type: 'error',
                position: 'top-right',
                autoClose: 10000,
              });
            }
          }
        }
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
